/**
 * Payment Verification Actions for Story 3: Independent Payment Verification
 * Manages pending verifications, upload proof, verify/reject actions
 */

// Action Types
export const SET_PENDING_VERIFICATIONS = "SET_PENDING_VERIFICATIONS";
export const SET_VERIFICATION_LOADING = "SET_VERIFICATION_LOADING";
export const SET_VERIFICATION_ERROR = "SET_VERIFICATION_ERROR";
export const UPLOAD_PAYMENT_PROOF_SUCCESS = "UPLOAD_PAYMENT_PROOF_SUCCESS";
export const VERIFY_PAYMENT_SUCCESS = "VERIFY_PAYMENT_SUCCESS";
export const REJECT_PAYMENT_SUCCESS = "REJECT_PAYMENT_SUCCESS";
export const SET_RECONCILIATION_REPORT = "SET_RECONCILIATION_REPORT";
export const SET_MISMATCH_ALERTS = "SET_MISMATCH_ALERTS";
export const SET_AUDIT_TRAIL = "SET_AUDIT_TRAIL";
export const SET_KASIR_USER_INFO = "SET_KASIR_USER_INFO";

// Action Creators
export const setPendingVerifications = (payload) => {
  return { type: SET_PENDING_VERIFICATIONS, payload };
};

export const setVerificationLoading = (payload) => {
  return { type: SET_VERIFICATION_LOADING, payload };
};

export const setVerificationError = (payload) => {
  return { type: SET_VERIFICATION_ERROR, payload };
};

export const uploadPaymentProofSuccess = (payload) => {
  return { type: UPLOAD_PAYMENT_PROOF_SUCCESS, payload };
};

export const verifyPaymentSuccess = (payload) => {
  return { type: VERIFY_PAYMENT_SUCCESS, payload };
};

export const rejectPaymentSuccess = (payload) => {
  return { type: REJECT_PAYMENT_SUCCESS, payload };
};

export const setReconciliationReport = (payload) => {
  return { type: SET_RECONCILIATION_REPORT, payload };
};

export const setMismatchAlerts = (payload) => {
  return { type: SET_MISMATCH_ALERTS, payload };
};

export const setAuditTrail = (payload) => {
  return { type: SET_AUDIT_TRAIL, payload };
};

export const setKasirUserInfo = (payload) => {
  return { type: SET_KASIR_USER_INFO, payload };
};
